<template>
  <div class="callback">
    <div class="d-flex justify-content-center align-items-center vh-100">
      <div class="d-flex align-items-center justify-content-center flex-column">
        <b-spinner
          variant="primary"
          label="Text Centered"
        />
        <div class="waiting mt-1">
          Logging in...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapActions } from 'vuex'

export default {
  name: 'OidcCallback',
  computed: {
  },
  mounted() {
    this.oidcSignInCallback()
      // eslint-disable-next-line no-unused-vars
      .then(redirectPath => {
      })
      .catch(err => {
        console.error(err)
        this.$router.push('/oidc-callback-error') // Handle errors any way you want
      })
  },
  methods: {
    ...mapActions('oidcStore', [
      'oidcSignInCallback',
    ]),
  },
}
</script>
